import type { LibraryMedia } from './api';
import { MediaPicker, restricaoDoCabecalho } from './MediaPicker';

export type FormatoDoCabecalho = 'image' | 'video' | 'document';

const NOME: Record<FormatoDoCabecalho, string> = {
  image: 'imagem',
  video: 'vídeo',
  document: 'documento',
};

/**
 * Mídia do cabeçalho do template (IMAGE/VIDEO/DOCUMENT) escolhida NA HORA —
 * mesmo picker do chatbot e da Biblioteca ("Escolher da galeria" → buscar ou
 * "+ Enviar" arquivo do computador), travado no tipo do cabeçalho e nos
 * limites da Meta. Usado na Campanha, no Novo atendimento e no template de
 * dentro da conversa. Não existe mais arte padrão salva no template.
 */
export function MidiaDoCabecalhoPicker({
  type,
  selectedId,
  selectedLabel,
  selectedMime,
  onSelect,
  onClear,
  dica,
}: {
  type: FormatoDoCabecalho;
  selectedId: number | null;
  selectedLabel?: string | null;
  selectedMime?: string | null;
  onSelect: (media: LibraryMedia) => void;
  onClear: () => void;
  dica?: string;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <span className="font-semibold text-[12px] text-n-700">
        Mídia do cabeçalho ({NOME[type]})
      </span>
      <MediaPicker
        selectedId={selectedId ?? undefined}
        selectedLabel={selectedLabel ?? undefined}
        selectedMime={selectedMime ?? undefined}
        onSelect={onSelect}
        onClear={onClear}
        restricao={restricaoDoCabecalho(type)}
      />
      <p className="text-[11px] text-n-500">
        {dica ?? 'A mídia escolhida vai no cabeçalho da mensagem.'}
      </p>
    </div>
  );
}
